module.exports = __webpack_public_path__ + "img/1579899095.cdeec17e.jpg";